module.exports = __webpack_public_path__ + "img/Tutorial_Deskriptor.820c5d80.jpg";